<template>
      <StyledDiv width="75%" height="350px">
                                          <StyledText
                                                  :fontSize="styled('fontSize-medium')"
                                          >                              Check out our CEO's Ted Talk:
                                                                         <br/>
                                                                         <br/>


                                  </StyledText>
        <StyledDiv
          :border="`1px solid ${styled('lightBlue')}`"
          borderRadius="5px"
          hoverBrightness="brightness(90%)"
          :backgroundColor="styled('white')"
          cursor="pointer"
          height="150px"
          width="75%"
          minWidth="300px"
        >
          <a
          href="https://www.ted.com/talks/cathy_callow_heusser_how_technology_can_help_revitalize_native_american_languages"
            target="_blank"
            class="anchor"
          >
      <StyledText
        :color="styled('pdfPink')"
        :fontSize="styled('fontSize-medium')"
        :smallTabletFontSize="styled('fontSize-mediumSmall')"
        :fontFamily="styled('fontFamily-GothamMedium')"
                            >
                              How technology can help revitalize Native American languages
                            </StyledText>
          </a>
        </StyledDiv>
        <br/>
        <br/>
              <StyledText
                :smallTabletFontSize="styled('fontSize-tiny')"
                textAlign="left"
                :fontSize="styled('fontSize-mediumSmall')"
                >The same AI-driven software mentioned in the TED talk works with English and Spanish to develop series of decodable stories with controlled introduction of sounds and words. </StyledText
              >

      </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
export default {
  components: {
    StyledDiv,
    StyledText
  },
  data() {
    return {
      contactForm: false,
      thanksBarDisplayed: false,
      errorBarDisplayed: false
    };
  },
  methods: {
    toggleCancel() {
      this.contactForm = false;
    },

    toggleContactForm() {
      this.contactForm = !this.contactForm;
    },
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style>
.anchor {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
@media (max-width: 768px) {
  .doubleWrap {
    flex-direction: column;
  }
  .dividerThing {
    width: 75%;
    height: 1px;
  }
}
</style>